import React from 'react';
import './navbar.css';
import {Link} from 'react-router-dom';

function Navbar() {
    return (
        <div className="navbar">
            <div className="navbar__div1">
                <div className="navbar__div6">
                <div className="navbar__div2">
                    <Link to="/" className="navbar__link1">
                        <h3>Radius</h3>
                    </Link>
                </div>
                <div className="navbar__div3">
                    <h3 className="navbar__link1">How you doin!!</h3>
                </div>
                </div>
                <div className="navbar__div4">
                    <div className="navbar__div5">
                        <a href="https://www.linkedin.com/in/kazuo-kaze-001161210/" className="navbar__link1"><h3>Contact</h3></a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar;
